import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import _ from "lodash";
import moment from "moment-timezone";
import styled from "styled-components";

import StatusLabel, { BookingStatuses } from "components/ui-kit/status-label";
import { Button, Container, Frame, Row, RowWrapper } from "components/ui-kit/styled-templates";

import BookingsApi from "api/bookings-api";
import DormitoriesApi from "api/dormitories-api";
import RoomsApi from "api/rooms-api";
import UniversityApi from "api/university-api";

import ModalsService from "services/modals-service";

import useBodyBackground from "hooks/useBodyBackground";
import { useStorageListener } from "hooks/useStorage";


const PreviewBookingPage = () => {
    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    useBodyBackground(`white`);

    const navigate = useNavigate();
    const { bookingId } = useParams();
    const booking = useStorageListener(`bookings.${bookingId}`, {});
    const { dormitoryId } = booking;
    const universities = useStorageListener(`universities`, {});
    const { universityId, details: dormitory, rooms } = useStorageListener(`dormitories.${dormitoryId}`, {});

    const handlers = {
        openDeleteBookinModality: () =>
            ModalsService.showModality({
                title: `Удаление бронирования`,
                description: `Вы уверены, что хотите удалить это бронирование?`,
                cancelButton: {
                    children: `Отмена`,
                    background: `gray`,
                },
                confirmButton: {
                    children: `Удалить`,
                    background: `red`,
                    onClick: async () => await BookingsApi.deleteBooking(bookingId),
                },
            }),
    };

    // @ts-ignore
    useEffect(async () => {
        if (!dormitory) {
            try {
                await DormitoriesApi.getDormitoryInfo(dormitoryId);
            } catch (error) {
                navigate(`/requests`);
            }
        }
    }, [dormitoryId, dormitory]);
    // @ts-ignore
    useEffect(() => {
        if (!dormitory && !dormitoryId) {
            RoomsApi.getDormitoryRooms(dormitoryId);
        }
    }, [dormitoryId, dormitory]);
    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);
    // @ts-ignore
    useEffect(() => {
        if (!booking.dormitoryId) {
            BookingsApi.getMyBookings();
        }
    }, [bookingId]);

    return (
        <>
            <HeaderWrapper>
                <Container>
                    <RowWrapper extra="@media (max-width: 991px) { flex-direction: column; };">
                        {/*<h1>#{booking?.timestamp}</h1>*/}
                        <h1>{moment(booking?.timestamp).format('DD.MM.YYYY HH:mm')}</h1>
                        <Row extra="gap: 24px; @media (max-width: 991px) { flex-direction: column; };">
                            <Button variant="outlined" background="red" onClick={handlers.openDeleteBookinModality}>
                                {t("el5ex0sarti")}
                            </Button>
                            <Link to={`/edit-booking/${bookingId}`}>
                                <Button variant="outlined" background="blue">
                                    {t("68xakcujy7h")}
                                </Button>
                            </Link>
                        </Row>
                    </RowWrapper>
                </Container>
            </HeaderWrapper>

            <Container extra={`align-items: flex-start;`}>
                <h2>{_.get(dormitory, `main-info.name`)}</h2>
                <StatusLabel status={booking.status}>{BookingStatuses[booking.status]}</StatusLabel>
                <Frame extra="flex-direction: row; flex-wrap: wrap; gap: 50px; margin: 30px 0; max-width: 450px; justify-content: space-between; @media (max-width: 991px) { flex-direction: column; };">
                    {[
                        { title: isRu ? `Дата въезда` : `Checkin date`, text: moment(_.get(booking, `dates.from`)).format(`DD.MM.YYYY`) },
                        { title: isRu ? `Дата выезда` : 'Checkout date', text: moment(_.get(booking, `dates.to`)).format(`DD.MM.YYYY`) },
                        { title: isRu ? `Кол-во мест:` : 'Number of places', text: _.get(booking, `quantity`) },
                        { title: isRu ? `Тип комнаты` : 'Room type', text: _.get(rooms, `${_.get(booking, `roomId`)}.details.type`) },
                    ].map(({ title, text }, index) => (
                        <Frame key={index} extra="gap: 8px; align-items: flex-start; width: 200px;">
                            <div>{title}</div>
                            <strong>{text}</strong>
                        </Frame>
                    ))}
                </Frame>

                <div className={'mb-2'} >
                    <strong>{'ФИО'}</strong>
                    <div>
                        {_.get(booking, `author.name`)}
                    </div>
                </div>

                <div className={'mb-2'} >
                    <strong>{'Телефон'}</strong>
                    <div>
                        {_.get(booking, `author.contacts.phone`)}
                    </div>
                </div>

                <div className={'mb-2'} >
                    <strong>{'Email'}</strong>
                    <div>
                        {_.get(booking, `author.contacts.email`)}
                    </div>
                </div>

                <div className={'mb-2'} >
                    <strong>{'Доп. информация'}</strong>
                    <div>
                        {_.get(booking, `author.additionalInformation`)}
                    </div>
                </div>

                <div>{t("pgw48vapbo")}</div>
                <strong style={{ maxWidth: `550px` }}>{_.get(booking, `comment`, `Нет комментариев`)}</strong>

                {/*<div  className={'mt-10'} >*/}
                {/*    {JSON.stringify(booking, null, 2)}*/}
                {/*</div>*/}

            </Container>
        </>
    );
};

const HeaderWrapper = styled(Frame)`
    width: 100vw;
    background: ${({ theme }) => theme.background.support};

    h1 {
        margin: 24px;
    }
`;

export default PreviewBookingPage;
